import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "yesNo" })
export class YesNoPipe implements PipeTransform {
  transform(value: boolean) {
    if (value === undefined || value === null) {
      return "";
    } else {
      return value ? "Yes" : "No";
    }
  }
}



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/shared/pipes/yesNo.pipe.ts